import { Skeleton } from "@mui/material";
import { TypographyH6 } from "@src/components/shared-ui-components/CustomTypography";
import { Flex } from "@src/components/shared-ui-components/Flex";
import { ErrorState, formatTimeUtctoEst } from "@src/constants";
import { FC } from "react";
import { LastUpdateMainWrapper, LastUpdatedWrapper } from "./style";

interface LastUpdatedPropsType {
  lastUpdatedTime: string | undefined;
  placeRight?: boolean;
  loading?: boolean;
}

const LastUpdated: FC<LastUpdatedPropsType> = ({
  lastUpdatedTime,
  placeRight = false,
  loading = false,
}) => {
  const getValues = (updatedTime: string | undefined) => {
    return updatedTime ? (
      <TypographyH6>{formatTimeUtctoEst(updatedTime)}</TypographyH6>
    ) : (
      <ErrorState />
    );
  };
  return (
    <LastUpdateMainWrapper placeRight={placeRight}>
      <LastUpdatedWrapper>
        <TypographyH6>Last Updated:&nbsp;</TypographyH6>
        {loading ? (
          <Flex>
            <Skeleton width="100%" />
          </Flex>
        ) : (
          getValues(lastUpdatedTime)
        )}
      </LastUpdatedWrapper>
    </LastUpdateMainWrapper>
  );
};

export default LastUpdated;
